cockpitApp.directive('iframeBreadcrumbs', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/iframe-breadcrumbs',
    controller: 'iframeBreadcrumbsController',
    controllerAs: 'iframeBreadcrumbsCtrl'
  };
});
